var map = {
	"./about-ob1.jpg": "d31e",
	"./about-ob2.jpg": "9347",
	"./home-covid1.jpg": "ed75",
	"./home-fitness1.jpg": "2e59",
	"./home-homefitness.jpg": "8398",
	"./home-kitch1.jpg": "38c2",
	"./home-med1.jpg": "de42",
	"./home-or-left-ad.png": "96dd",
	"./home-or-middle-ad.jpg": "2d65",
	"./home-or-right-ad.jpg": "d724",
	"./home-project-furniture.194b154e.jpg": "af61",
	"./home-project-furniture.jpg": "806b",
	"./home-select-enquiry.jpg": "1031",
	"./home-slider.jpg": "d4e3",
	"./home-slider1.jpg": "b60f",
	"./home-slider2.jpg": "b1c1",
	"./home-slider3.jpg": "f532",
	"./home_fitness1.jpg": "918e",
	"./home_fitness2.jpg": "c3b9",
	"./logo-bottom-text.png": "1b32",
	"./logo-no-text.png": "5b99",
	"./logo-text.png": "a993",
	"./overlay.png": "51cf",
	"./partner1.jpg": "b883",
	"./partner2.jpg": "ab37",
	"./partner3.jpg": "e0a6",
	"./partner4.jpg": "c8ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";